import React from 'react'

const FuelReports = () => {
  return (
    <div>FuelReports</div>
  )
}

export default FuelReports